export const vh = () => {
	resizer(get_vh);
	get_vh();
};

const get_vh = () => {
	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty("--vh", `${vh}px`);
};
export const resizer = (fn) => {
	window.addEventListener("resize", fn, true);
};

export let mouse_direction = null;

document.body.addEventListener(
	"wheel",
	(e) => {
		const x = parseInt(e.deltaX);
		const y = parseInt(e.deltaY);

		if (y > 0) {
			mouse_direction = "down";
		} else if (y < 0) {
			mouse_direction = "up";
		}
		if (x > 0) {
			mouse_direction = "right";
		} else if (x < 0) {
			mouse_direction = "left";
		}
	},
	true
);

let touchStartPosX = 0;
// let touchStartPosY = 0;
document.body.addEventListener(
	"touchmove",
	(e) => {
		const currentPageX = Math.round(e.touches[0].screenY);
		if (touchStartPosX === currentPageX) return;

		if (touchStartPosX - currentPageX > 0) {
			mouse_direction = "left";
		} else {
			mouse_direction = "right";
		}
		touchStartPosX = currentPageX;

		// const currentPageY = Math.round(e.touches[0].screenY);
		// if (touchStartPosY === currentPageY) return;

		// if (touchStartPosY - currentPageY >= 0) {
		// 	mouse_direction = "down";
		// } else {
		// 	mouse_direction = "up";
		// }
		// touchStartPosY = currentPageY;
	},
	true
);



export const disableZoomOnInputFocus = () => {
	setTimeout(() => {
		const inputs = document.getElementsByTagName("input");
		for (let i = 0; i < inputs.length; i++) {
			inputs[i].addEventListener("focus", function () {
				document.body.style.zoom = "1";
				document.documentElement.style.zoom = "1";
			});
		}
	}, 500);
};
